// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3BQ3W","tab":"ProcedureTabs_tab__17tBr"};